import { Component, inject } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { primaryColors, surfaceColors } from '../../constant/color-scheme.constant';

@Component({
    standalone: false,
    selector: 'app-theme-section',
    templateUrl: './theme-section.component.html',
    // 5px over 6px keeps the buttons on whole pixels in the 55px bar.
    host: {
        class: 'flex items-center gap-1 rounded-xl border border-[var(--topbar-section-border)] px-2 pb-[6px] pt-[5px]',
        'data-testid': 'topbar-theme-section',
    },
})
export class ThemeSectionComponent {
    readonly primaryColors = primaryColors;
    readonly surfaceColors = surfaceColors;

    readonly layoutService = inject(LayoutService);

    selectPrimary(colorName: string): void {
        this.layoutService.setPrimaryColor(colorName);
    }

    selectSurface(colorName: string): void {
        this.layoutService.setSurfaceColor(colorName);
    }

    get currentPrimary(): string {
        return this.layoutService.getPrimary();
    }

    get currentSurface(): string | null | undefined {
        return this.layoutService.getSurface();
    }
}
